export default "__VITE_ASSET__BLbFn5qP__"